module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "layout"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "layout-opacity"
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "dialog-layout"
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_vm._t("default"), _vm._v("\n          " + _vm._s(_vm.content) + "\n        ")], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-buttons"
  }, [(_vm.type == 'confirm') ? _c('button', {
    staticClass: "button-no",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.buttons[1]))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button-ok",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.buttons[0]))])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e81fa6de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/modal.vue
// module id = 281
// module chunks = 36